import { jsx } from "react/jsx-runtime";
import AntCollapse from "antd/es/collapse";
import classnames from "../../utils/classnames.js";
import Icon from "../Icon/Icon.js";
import './Collapse.css';/* empty css              */
const Collapse = ({
  className,
  classNameWrapper,
  expandIcon = ({ isActive }) => /* @__PURE__ */ jsx(Icon, { name: isActive ? "minus" : "plus", sticker: "collapse-expand-icon", size: 20 }),
  expandIconPosition = "end",
  ...props
}) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-collapse-wrapper", classNameWrapper), children: /* @__PURE__ */ jsx(
    AntCollapse,
    {
      expandIcon,
      expandIconPosition,
      className: classnames("perxis-auto-collapse", className),
      ...props
    }
  ) });
};
export {
  Collapse as default
};
//# sourceMappingURL=Collapse.js.map
